/**
 * Track state concerning if JIPT is being used, or not.
 */
// eslint-disable-next-line no-restricted-imports -- required to avoid a circular dependency
import type {DomInsertCheckFn} from "@khanacademy/perseus";
import {RequestInfo} from "@khan/shared-core";

export default {
    // Default to checking if the language is "en-pt" which is true
    // when viewing any page on translate.khanacademy.org.  This property
    // will also be true when viewing any of the translations editor routes.
    get useJIPT(): boolean {
        const regex = /^\/(devadmin\/)?translations\/edit\//;
        return (
            // TODO(LP-12335): Move useJIPT from PerseusDependencies to APIOptions
            // eslint-disable-next-line no-restricted-syntax -- this is a getter so we can't pass the location in
            regex.test(window.location.pathname) ||
            RequestInfo.kaLocale === "en-pt"
        );
    },

    // Collect the JIPT DOM insertion checks. This logic is scattered all over
    // the application and it's easiest to have a pseudo-global that holds
    // them all.
    domInsertChecks: [] as Array<DomInsertCheckFn>,
};
